/**
 * Richtung des Trendpfeils auf einer Kennzahl-Kachel.
 *
 * Der Pfeil zeigt, wohin sich die ZAHL bewegt hat — nicht, ob das gut ist. Die
 * Bewertung steckt allein in der Farbe (grün bei guter, rot bei schlechter
 * Entwicklung) und darf den Pfeil nicht drehen.
 *
 * ⚠️ F29 (behoben 19.10.2026): Bis dahin folgte der Pfeil der Bewertung
 * (`good ? TrendingDown : TrendingUp` in `components/ui/KpiCard.tsx`). Auf einer
 * Kachel, bei der MEHR besser ist — etwa der Probezeit-Retentionrate —, zeigte ein
 * Anstieg deshalb einen grünen Pfeil nach UNTEN. Zahl und Farbe stimmten, nur das
 * Symbol widersprach ihnen. Bei Kacheln mit „weniger ist besser" stimmte er zufällig,
 * weil sich dort beide Drehungen aufhoben. Vorhanden seit `d922600`; betroffen waren
 * die fünf Kacheln auf „Onboarding-Erfolg". Das FK-Dashboard und das KPI-Reporting
 * haben eigene Kachel-Bausteine und waren nie betroffen.
 *
 * Die Datei bleibt bewusst ohne React, damit die Regel ohne Oberfläche testbar ist
 * (dieselbe Trennung wie `lib/probezeit-anzeige.ts` und `lib/tabellen-sortierung.ts`).
 */

/** „gleich" heißt: kein Pfeil, sondern der waagerechte Strich. */
export type TrendRichtung = "hoch" | "runter" | "gleich";

/**
 * Wohin zeigt der Pfeil bei dieser Veränderung?
 *
 * Unbrauchbare Zahlen (NaN, Unendlich) ergeben „gleich" — lieber kein Pfeil als ein
 * geratener. Vorher zeichnete die Kachel in diesem Fall einen Pfeil nach oben, weil
 * weder `good` noch `bad` zutraf und der Sonst-Zweig griff.
 */
export function trendRichtung(trend: number): TrendRichtung {
  if (!Number.isFinite(trend) || trend === 0) return "gleich";
  return trend > 0 ? "hoch" : "runter";
}
